var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagEgypt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0107422C9.12055 0.0107422 3.25587 4.35274 0.995178 10.4456H31.0049C28.7441 4.35274 22.8794 0.0107422 16 0.0107422Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C22.8794 32.0107 28.7441 27.6687 31.0048 21.5759H0.995178C3.25587 27.6687 9.12055 32.0107 16 32.0107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 14.2717H17.3913C17.3913 13.5033 16.7683 12.8804 15.9999 12.8804C15.2316 12.8804 14.6086 13.5033 14.6086 14.2717H10.4347C10.4347 15.0401 11.104 15.663 11.8724 15.663H11.826C11.826 16.4314 12.4489 17.0543 13.2173 17.0543C13.2173 17.8227 13.8402 18.4456 14.6086 18.4456H17.3913C18.1597 18.4456 18.7826 17.8227 18.7826 17.0543C19.551 17.0543 20.1739 16.4314 20.1739 15.663H20.1276C20.8959 15.663 21.5652 15.0401 21.5652 14.2717Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEgypt);
export default __webpack_public_path__ + "static/media/flag_egypt.e653189a3b5cf314abc83bcaec82351c.svg";
export { ForwardRef as ReactComponent };